module.exports = __webpack_public_path__ + "static/img/长图设计-平面合成长图.f9d8382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/长图设计-平面合成长图.png
// module id = /6oE
// module chunks = 1